import { NgModule } from '@angular/core';
import { LoginComponent } from './components/login/login.component';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from './services/guards/authentication.guard';
import { ProfileComponent } from './components/profile/profile.component';
import { ChangepasswordComponent } from './components/password/changepassword/changepassword.component';
import { ForgottenPasswordComponent } from './components/password/forgotten-password/forgotten-password.component';
import { ResetPasswordGuard } from './services/guards/reset-password-guard';

const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'profile' },
    { path: 'login', component: LoginComponent },
    { path: 'profile', component: ProfileComponent, canActivate: [AuthenticationGuard] },
    { path: 'changepassword', component: ChangepasswordComponent, canActivate: [ResetPasswordGuard] },
    { path: 'forgottenpassword', component: ForgottenPasswordComponent, canActivate: [ResetPasswordGuard] },
    {
        path: 'management',
        loadChildren: () => import('./modules/general/management/management.module').then((mod) => mod.ManagementModule),
    },
    {
        path: 'definitions',
        loadChildren: () => import('./modules/general/definitions/definitions.module').then((mod) => mod.DefinitionsModule),
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', preloadingStrategy: PreloadAllModules })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
